module.exports = __webpack_public_path__ + "img/PH11.49a7990e.png";